import config from '../config.json'
import Keycloak from 'keycloak-js'

// TODO to common
const backendName = process.env.VUE_APP_BACKEND
  ? process.env.VUE_APP_BACKEND
  : 'local'

const keycloak = new Keycloak({
  url: `${config.keycloak[backendName].host}:${config.keycloak[backendName].options.port}/`,
  realm: config.keycloak[backendName].clientConfig.realm,
  clientId: config.keycloak[backendName].clientConfig.client_id,
})

const VueKeycloak = {
  install(Vue, _options) {
    Vue.prototype.$keycloak = keycloak
  },
  async init() {
    let authResult = false
    try {
      authResult = await keycloak.init({
        onLoad: 'check-sso',
        // https://github.com/keycloak/keycloak/issues/14742
        // https://www.keycloak.org/docs/latest/securing_apps/#_javascript_adapter
        // responseMode: 'query',
        // not supported by modern browsers: https://www.keycloak.org/docs/latest/securing_apps/#_modern_browsers
        checkLoginIframe: false,
        // not supported by modern browsers: https://www.keycloak.org/docs/latest/securing_apps/#_modern_browsers
        // silentCheckSsoRedirectUri:
        // window.location.origin + '/silent-check-sso.html',
        // TODO: debug mode, remove once in prod
        enableLogging: true,
      })

      // TODO MGA: init may trigger a navigation ?? to check
      console.debug('[keycloakPlugin.init] init Keycloak result:', authResult)
    } catch (keycloakInitError) {
      console.error(
        '[keycloakPlugin.init][error] init Keycloak error:',
        keycloakInitError,
      )
    }

    return authResult
  },
}
export default VueKeycloak
